import Indicator from "@/components/shared/Indicator";
import { IntegrationLogStatus, IntegrationLogVo } from "@/types";
import { wrapUpDescriptions } from "@/utils/info";
import { Descriptions } from "antd";
import { useMemo } from "react";

interface OrderDeleteInfoProps {
  event: IntegrationLogVo;
}

export function OrderCreateLogDetail(props: OrderDeleteInfoProps) {
  const { event } = props;
  const log: any = event.log as Record<string, unknown>;

  return (
    <div>
      <Indicator label={"Detail"} />
      <div>
        {event.status === IntegrationLogStatus.Success ? (
          <SuccessDetail />
        ) : (
          <FailedDetail log={log} />
        )}
      </div>
    </div>
  );
}

function SuccessDetail() {
  return (
    <div>
      <div></div>
    </div>
  );
}

function FailedDetail({
  log,
  className,
  labelStyle,
  contentStyle,
}: {
  log: any;
  className?: string;
  labelStyle?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
}) {
  const processed = useMemo(() => {
    const error = log["message"];
    let cubeOrder = log["cubeOrder"];
    let bigDict = {};
    if ("boxUpcStockList" in cubeOrder) {
      const { boxUpcStockList, stockRecord } = cubeOrder;
      boxUpcStockList.map((item: any) => {
        const upcBarcode = item["upcBarcode"];
        bigDict = {
          ...bigDict,
          [`${upcBarcode} Qty`]: item["quantity"],
          [`${upcBarcode} Product ID`]: item["productId"],
          [`${upcBarcode} Product Name`]: item["productName"],
          [`${upcBarcode} Single Box Quantity`]: item["singleBoxQuantity"],
        };
      });
      return {
        ...stockRecord,
        ...bigDict,
        error,
      };
    } else if ("orderList" in cubeOrder) {
      cubeOrder = cubeOrder["orderList"][0];
      const { packageList, receiveAddress, ...rest } = cubeOrder;
      packageList["itemList"].forEach((item: any) => {
        bigDict = {
          [`${item["sku"]} Qty`]: item["qty"],
        };
      });
      return {
        error,
        ...rest,
        ...receiveAddress,
        ...bigDict,
      };
    }
  }, [log]);

  const keyValues = useMemo(() => {
    const dataProps = Object.keys(processed).map((key) => ({
      key,
      label: key,
    }));
    const items = wrapUpDescriptions(
      dataProps,
      processed as Record<string, any>,
    );
    return items.map((item) => ({
      ...item,
      span: 1,
    }));
  }, [processed]);

  const styles = useMemo(
    () => ({ label: labelStyle, content: contentStyle }),
    [labelStyle, contentStyle],
  );

  return (
    <Descriptions
      column={2}
      size="small"
      className={className}
      bordered
      items={keyValues}
      styles={styles}
    />
  );
}
